import { AxiosError } from "axios";

import api from "services/api";
import { routers_constants } from "services/constants";
import { IBaseRestAPIResponse } from "services/interface";

export interface ISystemNotificationrBody {
  id: number;
  userId: number;
  message: string;
  url: string;
  createIn: Date;
  read: boolean;
}

export const systemNotificationService = {
  getAllByUser: async (userId: number) => {
    try {
      const uri = routers_constants.systemNotification.getAllByUser(userId);
      const { data, status } = await api.get<IBaseRestAPIResponse>(uri);
      return { data, status };
    } catch (error) {
      const errorReturn = error as AxiosError;
      const { data, status } = errorReturn.response as IBaseRestAPIResponse;
      return { data, status };
    }
  },
  add: async (body: ISystemNotificationrBody) => {
    try {
      const uri = routers_constants.systemNotification.add;
      const { data, status } = await api.post(uri, body);
      return { data, status };
    } catch (error) {
      const errorReturn = error as AxiosError;
      const { data, status } = errorReturn.response as IBaseRestAPIResponse;
      return { data, status };
    }
  },
  setReaded: async (notificationId: number) => {
    try {
      const body = [
        {
          op: "replace",
          value: true,
          path: "read",
        },
      ];

      const uri =
        routers_constants.systemNotification.setReaded(notificationId);

      const { data, status } = await api.patch(uri, body);
      return { data, status };
    } catch (error) {
      const errorReturn = error as AxiosError;
      const { data, status } = errorReturn.response as IBaseRestAPIResponse;
      return { data, status };
    }
  },
  setReadedAll: async (notifications: Array<ISystemNotificationrBody>) => {
    try {
      const uri = routers_constants.systemNotification.setReadedAll;
      const newBodys: Array<ISystemNotificationrBody> = notifications.map(
        (item) => {
          return { ...item, read: true };
        },
      );
      const { data, status } = await api.post(uri, newBodys);
      return { data, status };
    } catch (error) {
      const errorReturn = error as AxiosError;
      const { data, status } = errorReturn.response as IBaseRestAPIResponse;
      return { data, status };
    }
  },
};
